import { HashIcon, SearchIcon } from 'lucide-react';
import { Form, useNavigate , Link } from '@remix-run/react';
import { useState } from 'react';
import { Badge } from '~/components/ui/badge';

export const Hero = () => {
  const navigate = useNavigate();
  const [inputQuery, setInputQuery] = useState<string>('');

  const onSearch = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    console.dir(navigate);

    const queryParams = new URLSearchParams();

    if (inputQuery) {
      queryParams.append('query', inputQuery);
    }

    navigate(`/pedals?${queryParams.toString()}`);
  };

  return (
    <div className={'max-w-[700px] w-[700px] mx-4 mt-[32px] md:mt-[64px] bg-[rgba(255,255,255,0.96)] text-black py-9 md:py-14 px-8 md:px-20 inline-block font-bold text-center rounded-lg'}>
      <div className={'text-md md:text-xl'}>
        ざっくり検索で欲しいエフェクターが見つかるデータベース
      </div>
      <div className='flex justify-center items-center mt-3'>
        <img
          src={'/stomp-base_logo_alpha.png'}
          alt={'stomp-base_logo'}
          className='w-[260px] md:w-[420px]'
        />
      </div>

      <div className="relative flex-1 mt-5">
        <Form onSubmit={onSearch}>
          <input
            className="rounded-md border-2 border-neutral-400 outline-neutral-600 bg-gray-50 px-3 py-2 text-[13px]/tight text-neutral-600 font-medium placeholder:text-inherit placeholder:opacity-50 !pr-12 w-full"
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            placeholder="キーワードで検索"
            spellCheck="false"
            maxLength={512}
            name="query"
            value={inputQuery || ''}
            onChange={(e) => setInputQuery(e.target.value)}
          />
          <div className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center gap-2">
            <button type="submit" className="hover:opacity-50">
              <SearchIcon height={16} width={16} className='text-neutral-500' />
            </button>
          </div>
        </Form>
      </div>

      <div className={'flex flex-wrap gap-x-3 gap-y-2 mt-4'}>
        <SearchBadge to={'/pedals?tags=od'} label={'オーバードライブ'} needHash={true} />
        <SearchBadge to={'/pedals?tags=dl'} label={'ディレイ'} needHash={true} />
        <SearchBadge to={'/pedals?tags=me'} label={'マルチエフェクター'} needHash={true} />
        <SearchBadge to={'/pedals?brands=boss'} label={'BOSS'} />
        <SearchBadge to={'/pedals?brands=xoti'} label={'Xotic'} />
        <SearchBadge to={'/pedals?brands=eqd'} label={'EarthQuaker Devices'} />
      </div>
    </div>
  );
};

const SearchBadge = ({ to, label, needHash = false }: { to: string, label: string, needHash?: boolean }) => {
  return (
    <Link to={to}>
      <Badge
        variant="outline"
        className={'min-h-[28px] rounded-3xl text-[11px]  bg-slate-100 border-slate-100 hover:bg-slate-200 py-1 px-2 text-slate-600 font-normal gap-[0.1ch]'}
      >
        {needHash && (
          <HashIcon className="h-[11px] w-[11px]" />
        )}
        {label}
      </Badge>
    </Link>
  );
}
